<template>
  <div class="color-card-container">
    <div class="nav-section">
      <!-- 左侧：网格按钮菜单（menulist） -->
      <div class="button-row">
        <el-button
          class="menu-btn"
          v-for="(item, index) in menulist"
          :key="index"
          @click="
            handleMenuClick(
              item.content,
              `/publish-clothes/basicData/${item.name}`
            )
          "
        >
          {{ item.content }}
        </el-button>
      </div>
      <!-- 中间：列表式菜单（menulists 里的部分项） -->
      <div class="list-row">
        <a
          href="javascript:void(0)"
          v-for="(item, index) in listMenu"
          :key="index"
          class="menu-link list-item"
          @click="
            handleMenuClick(
              item.content,
              `/publish-clothes/basicData/${item.name}`
            )
          "
        >
          <i class="el-icon-finished" />
          {{ item.content }}
        </a>
      </div>
      <!-- 右侧：下划线式菜单（menulists 里的剩余项） -->
      <div class="report-row">
        <a
          href="javascript:void(0)"
          v-for="(item, index) in reportMenu"
          :key="index"
          class="menu-link report-item"
          @click="
            handleMenuClick(
              item.content,
              `/publish-clothes/basicData/${item.name}`
            )
          "
        >
          {{ item.content }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();
const { proxy } = getCurrentInstance();
const $api = proxy.$api;

// 响应式数据
const menulist = ref([]);
const menulists = ref([]);

// 计算属性
const listMenu = computed(() => {
  return menulists.value;
});
// const reportMenu = computed(() => {
//   return menulists.value.filter((item) => item.id === 14);
// });
const reportMenu = computed(() => []);

// 菜单点击事件
const handleMenuClick = (title, path) => {
  console.log(title, path, "返回的对不对");
  store.dispatch("addMenuClickRecords", { title, path });
  router.push(path);
};

// 获取菜单接口
const users = async () => {
  try {
    const res = await $api.My.gets({});
    menulist.value =
      res?.data?.data.list.filter((item) => item.content == "基础资料")[0]
        ?.childrenList || [];
    console.log(menulist.value, "aassas");
    // menulists.value =
    //   res?.data?.data.list
    //     .filter((item) => item.content == "色卡管理")[0]
    //     ?.childrenList.filter(
    //       (item) => item.id == 12 || item.id == 13 || item.id == 14
    //     ) || [];
  } catch (error) {
    console.error("获取菜单列表失败：", error);
    menulist.value = [];
    menulists.value = [];
  }
};

onMounted(() => {
  users();
});
</script>

<style lang="scss" scoped>
.color-card-container {
  width: 100%;
  min-height: 100%;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
}
.nav-section {
  display: flex;
  align-items: flex-start;
  gap: 80px;
}
/* 左侧：网格按钮 */
.button-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 30px;
}
.menu-btn {
  width: 150px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  margin: 0;
  &:hover {
    background-color: #f9f9f9;
  }
}
/* 中间：列表菜单（带图标） */
.list-row {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-top: 50px;
}
.list-item {
  color: #333;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  i {
    margin-right: 6px;
  }
}
/* 右侧：下划线菜单 */
.report-row {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-top: 50px;
}
.report-item {
  color: #333;
  font-size: 14px;
  text-decoration: none;
  border-bottom: 2px solid #333;
  padding-bottom: 4px;
  cursor: pointer;
}
/* 响应式适配 */
@media screen and (max-width: 1100px) {
  .button-row {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 992px) {
  .button-row {
    grid-template-columns: repeat(2, 1fr);
  }
  .nav-section {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
  .list-row,
  .report-row {
    padding-top: 0;
  }
}
@media screen and (max-width: 720px) {
  .button-row {
    grid-template-columns: 1fr;
  }
}
</style>
